<template>
  <div>
    <div class="bto-sb-widget bto-sb-widget-prematch-us bto-sb-widget-markets-us bto-sb-widget-markets-direct-us">
      <div class="bto-sb-widget-title bto-sb-collapsed" :class="{ 'bto-sb-show': showHideMarket(tab.id) }" @click.prevent="toggleShowHideMarket(tab.id)">
        <h3>{{t('M.DirectBets')}}</h3>
      </div>
      <div class="bto-sb-widget-content" v-if="showHideMarket(tab.id)">
        <div class="bto-sb-market-wrap-items">
          <div class="bto-sb-market-items">
            <div class="bto-sb-market-item" v-for="(outright, idx) in directBets" :key="'db_'+idx">
              <span class="bto-sb-market-name"
                >{{ outright.name }}
                <span class="bto-sb-market-outrights-dates">
                  <i class="bto-sb-market-outrights-end-date">({{t("OutrightEndDate")}}: {{ outright.endDate }})</i>
                  <i v-if="showBettingEndDate" class="bto-sb-market-outrights-end-betting">({{t("OutrightEndBetting")}}: {{ outright.bettingEndDate }})</i>
                </span>
              </span>
              <span class="bto-sb-event-odd">
                <MatchOddComponent
                  :match="outright" 
                  :isDirectOutright="true" 
                  :outcome="outright.outcomes[0]" 
                  :isOutright="true" 
                  :isOutrightInDetails="true"
                />
              </span>
            </div>
          </div>
        </div>
        <div class="bto-sb-widget-footer" v-if="showHideMoreBtn(tab.id)">
          <a class="bto-sb-more-item" :class="{ 'bto-sb-less': !isItCollapsed(tab.id), 'bto-sb-show': isItCollapsed(tab.id) }" @click.prevent="toggleMoreLessDirectBets"
            >{{ !isItCollapsed(tab.id) ? t("Mobile.ShowLess") : t("Mobile.ShowMore") }}
          </a>
        </div>
      </div>
    </div>
    <div v-for="(outright, idx) in multiOutrights" :key="'mo_'+idx" class="bto-sb-widget bto-sb-widget-prematch-us bto-sb-widget-markets-us bto-sb-category-outrights-us">
        <div class="bto-sb-widget-title bto-sb-collapsed" :class="{ 'bto-sb-show': showHideMarket(outright.id) }" @click.prevent="toggleShowHideMarket(outright.id)">
          <h3>{{outright.name}}</h3>
          <div class="bto-sb-category-outrights-dates">
            <span class="bto-sb-category-outrights-end-date">({{t("OutrightEndDate")}}: {{outright.endDate}})</span>
            <span v-if="showBettingEndDate" class="bto-sb-category-outrights-end-betting">({{t("OutrightEndBetting")}}: {{outright.bettingEndDate}})</span>
          </div>
        </div>
        <div class="bto-sb-widget-content" v-if="showHideMarket(outright.id)">
          <div class="bto-sb-market-wrap-items">
            <div class="bto-sb-market-items">
              <div class="bto-sb-market-item" v-for="(outcome, idx) in outright.outcomes.slice(0, Math.ceil(outright.outcomes.length / 2))" :key="'mo_s1_'+idx">
                <span class="bto-sb-market-name">{{outcome.name}}</span>
                <span class="bto-sb-event-odd bto-sb-odd-dw-2">
                  <MatchOddComponent
                   :match="outright" 
                   :outcome="outcome" 
                   :isOutright="true" 
                   :isOutrightInDetails="true" 
                   :key="'mo_s1_'+idx" 
                   :isUsLayout="true"
                  />
                </span>
              </div>
            </div>
            <div class="bto-sb-market-items">
              <div class="bto-sb-market-item" v-for="(outcome, idx) in outright.outcomes.slice(Math.ceil(outright.outcomes.length / 2, outright.outcomes.length))" :key="'mo_s2_'+idx">
                <span class="bto-sb-market-name">{{outcome.name}}</span>
                <span class="bto-sb-event-odd">
                  <MatchOddComponent
                   :match="outright" 
                   :outcome="outcome" 
                   :isOutright="true" 
                   :isOutrightInDetails="true" 
                   :key="'mo_s2_'+idx"
                   :isUsLayout="true"
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="bto-sb-widget-footer" v-if="showHideMoreBtn(outright.id)">
            <a class="bto-sb-more-item" :class="{ 'bto-sb-less': !isItCollapsed(outright.id), 'bto-sb-show': isItCollapsed(outright.id) }" @click.prevent="toggleShowHideOdds(outright.id)"
              >{{ !isItCollapsed(outright.id) ? t("Mobile.ShowLess") : t("Mobile.ShowMore") }}
            </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MatchOddComponent from '../../../../components/common/match/match-odd-component';

export default {
  name: "OutrightsTabMarketUS",
  data() {
    return {
      defaultVisibleOdds: +APP_SETTINGS.settings.outcomesToShowByDefault || Infinity,
      expandedMarkets: [],
      shrunkenOutrights: [],
      outrightsWithShowMoreBtn: [],
      directBets: [],
      multiOutrights: [],
      showBettingEndDate: APP_SETTINGS.settings.showBettingEndDate,
      outrightsCollapsed: APP_SETTINGS.settings.outrightsCollapsedByDefault,
    };
  },
  components: {
    MatchOddComponent
  },
  props: {
    tab: {
      type: Object,
      required: true,
    },
    match: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.directBets = this.tab.directOutrights;
    this.multiOutrights = this.tab.multiOutrights;
    if (this.tab.directOutrights.length > this.defaultVisibleOdds) {
      this.outrightsWithShowMoreBtn.push(-1);
      this.toggleMoreLessDirectBets();
      if (this.shrunkenOutrights.indexOf(-1) === -1) {
        this.shrunkenOutrights.push(-1);
      }
    }
    if (this.outrightsCollapsed) {
      this.expandedMarkets.push(-1);
    }
    this.tab.multiOutrights.forEach((outright) => {
      if (this.outrightsCollapsed) {
        this.expandedMarkets.push(outright.id);
      }
      if ((outright.outcomes.length / 2) > this.defaultVisibleOdds) {
        this.outrightsWithShowMoreBtn.push(outright.id);
        this.removeExtraOdds(outright.id)
        if (this.shrunkenOutrights.indexOf(outright.id) === -1) {
          this.shrunkenOutrights.push(outright.id);
        }
      }
    })
  },
  methods: {
    removeExtraOdds(outrightId) {
      const outrights = [];
      this.tab.multiOutrights.forEach((outright) => {
        if (outright.id !== outrightId) {
          outrights.push(outright)
        }
        if (outright.id === outrightId) {
          const rowsToBeRemoved = Math.ceil((outright.outcomes.length / 2) - this.defaultVisibleOdds);
          if (rowsToBeRemoved > 0) {
            const firstColumn = outright.outcomes.slice(0, Math.ceil(outright.outcomes.length / 2));
            const secondColumn = outright.outcomes.slice(Math.ceil(outright.outcomes.length / 2, outright.outcomes.length));
            if (outright.outcomes.length % 2 === 0) {
              firstColumn.splice(-rowsToBeRemoved);
              secondColumn.splice(-rowsToBeRemoved);
            }
            if (outright.outcomes.length % 2 !== 0) {
              firstColumn.splice(-rowsToBeRemoved);
              secondColumn.splice(-(rowsToBeRemoved - 1));
            }
            outrights.push({...outright, outcomes: [...firstColumn, ...secondColumn]});
            this.shrunkenOutrights.push(outrightId);
          }
        }
      })
      this.multiOutrights = outrights;
    },
    showHiddenOdds(outrightId) {
      const match = this.tab.multiOutrights.find(x => x.id === outrightId);
      const index = this.multiOutrights.findIndex((outright) => outright.id === outrightId)
      const copy = [...this.multiOutrights]
      copy.splice(index, 1, match);
      this.multiOutrights = copy;
      this.shrunkenOutrights.splice(this.shrunkenOutrights.indexOf(outrightId), 1);
    },
    toggleShowHideOdds(outrightId) {
      if (this.shrunkenOutrights.indexOf(outrightId) === -1) {
        return this.removeExtraOdds(outrightId);
      }
      this.showHiddenOdds(outrightId);
    },
    toggleMoreLessDirectBets() {
      const copyOfDirectBets = [...this.tab.directOutrights];
      if (this.shrunkenOutrights.indexOf(-1) === -1) {
        copyOfDirectBets.splice(-this.defaultVisibleOdds);
        this.directBets = copyOfDirectBets;
        this.shrunkenOutrights.push(-1);
        return;
      }
      this.directBets = copyOfDirectBets;
      this.shrunkenOutrights.splice(this.shrunkenOutrights.indexOf(-1), 1)
    },
    toggleShowHideMarket(outrightId) {
      if (this.expandedMarkets.indexOf(outrightId) === -1) {
        this.expandedMarkets.push(outrightId)
      } else {
        this.expandedMarkets.splice(this.expandedMarkets.indexOf(outrightId), 1);
      }
    },
    showHideMarket(outrightId) {
      return this.expandedMarkets.indexOf(outrightId) === -1 ? true : false;
    },
    showHideMoreBtn(outrightId) {
      return this.outrightsWithShowMoreBtn.indexOf(outrightId) !== -1 ? true : false;
    },
    isItCollapsed(outrightId) {
      return this.shrunkenOutrights.indexOf(outrightId) === -1 ? false : true;
    }
  },
};
</script>

<style scoped>
  div.bto-sb-widget.bto-sb-widget-prematch-us.bto-sb-widget-markets-us.bto-sb-category-outrights-us {
    margin-bottom: 5px !important;
  }
</style>